export default "__VITE_ASSET__eozT_0a0__"